export const DonorActions = {
    handleDonorEdit: (donorId: number, centerId: number) => {
        window.location.href = `center/${centerId}/donor/${donorId}/profile/donor-data`;
    },
    handleVoucherHolders: (id: number, centerId: number) => {
        window.location.href = `center/${centerId}/donor/${id}/profile/vouchers`;
    },
    handleSeeDash: (registationId: number, centerId: number) => {
        window.location.href = `/center/${centerId}/donors/donor-intake/details/${registationId}`;
    },
    handleCryoOrder: (id: number, centerId: number) => {
    },
    handleApply: (id: number, centerId: number) => {
        window.location.href = '/center/' + centerId + '/donors/watr/add-request?donorId=' + id;
    },
    handleVoucherRecipient: (id: number, centerId: number) => {
        window.location.href = `center/${centerId}/recipient/${id}/profile/general`;
    }
}